module.exports = __webpack_public_path__ + "fepro/img/warning.3d37e5df.png";